import { placeFragment } from '@/services/fragments'

export const placesByUserQuery = /* GraphQL */ `
  query PlacesByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placesByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...placeData
      }
      nextToken
    }
  }
  ${placeFragment}
`

export const placesByOrganizationQuery = /* GraphQL */ `
  query PlacesByOrganization(
    $organizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placesByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...placeData
      }
      nextToken
    }
  }
  ${placeFragment}
`

export const placesByMasterOrganizationQuery = /* GraphQL */ `
  query PlacesByMasterOrganization(
    $organizationMasterID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placesByMasterOrganization(
      organizationMasterID: $organizationMasterID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...placeData
      }
      nextToken
    }
  }
  ${placeFragment}
`

export const listPlacesQuery = /* GraphQL */ `
  query ListPlaces(
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlaces(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        ...placeData
      }
      nextToken
    }
  }
  ${placeFragment}
`

export const getPlaceByIdQuery = /* GraphQL */ `
  query GetPlaceById($id: ID!) {
    getPlace(id: $id) {
      ...placeData
    }
  }
  ${placeFragment}
`
